export const experienceData = [
    {
        id: 1,
        company: "I'm Freshers." ,
        jobtitle: 'Looking for a challenging role as a fullstack developer.',
        startYear: '2022',
        endYear:'2022'
    },
   
]


//schema for entering the data

    // {
    //     id: 3,
    //     company: '',
    //     jobtitle: '',
    //     startYear: '',
    //     endYear: ''
    // },